<script setup>
import { ref, computed, onMounted } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { usePlanningStore } from '@/stores/planning.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  modelValue: { type: [Number, null], default: null },
  label: { type: String, default: null },
  readonly: { type: Boolean, default: false },
  clearable: { type: Boolean, default: true },
})
const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const planningStore = usePlanningStore()
const webSiteStore = useWebSiteStore()

const selectableCompanies = computed(() =>
  planningStore.companies.filter(c => !c.is_rental && (!c.archived || c.id === props.modelValue)),
)

const filteredCompanies = ref([])
const onFilter = (val, update) => {
  update(() => {
    filteredCompanies.value = val
      ? selectableCompanies.value.filter(c => c.name?.toLowerCase().includes(val.toLowerCase()))
      : selectableCompanies.value
  })
}

const onNewValue = (inputValue, done) => {
  const name = inputValue.trim()
  if (!name) return
  const existing = selectableCompanies.value.find(c => c.name?.toLowerCase() === name.toLowerCase())
  done(existing ? existing.id : name, 'add-unique')
}

onMounted(async () => {
  if (!planningStore.companies.length) await planningStore.fetchCompaniesAsync({}, true)
  filteredCompanies.value = selectableCompanies.value
})
</script>

<template>
  <q-select
    :model-value="modelValue"
    :label="label || i18n.t('common.company')"
    option-value="id"
    option-label="name"
    emit-value
    map-options
    :options="filteredCompanies"
    :clearable="clearable && !readonly"
    :readonly="readonly"
    use-input
    fill-input
    hide-selected
    new-value-mode="add-unique"
    :input-debounce="webSiteStore.getInputDebounce()"
    @filter="onFilter"
    @new-value="onNewValue"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
